import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { MyUserGroup } from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile'
import Button from '@Components/Buttons/Button'
import { editRightsholderUser } from '@App/api/routes/rightsholder/rightsholderUser'
import { useParams } from 'react-router'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { PermissionGroups, UserInfo } from '@Entities/user/user'
import EditActionsGroupsTable from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/UserPermissionsModal/ChangePermissionPopup/EditActionsGroupsTable'
import { PARAM } from '@App/navigation/param'

interface ChangePermissionPopupProps {
    myUserGroups: MyUserGroup[]
    setRightsholderUser: (userInfo: UserInfo) => void
    setUsersGroup: (user: UserInfo) => void
    getUsersForUser: (user: UserInfo) => void
    onCancelEdit: (user: UserInfo) => void
    onCloseConfirmPopup: () => void
    editActionsGroups: MyUserGroup[]
    rightsholderUser: UserInfo
}

const ChangePermissionPopup = (props: ChangePermissionPopupProps) => {
    const params = useParams<typeof PARAM>()
    const { popupStore } = useContext<RootStore>(StoresContext)
    const {
        myUserGroups,
        setRightsholderUser,
        setUsersGroup,
        getUsersForUser,
        onCancelEdit,
        onCloseConfirmPopup,
        editActionsGroups,
        rightsholderUser,
    } = props

    const onConfirm = async () => {
        const rightsHolderId = Number(params.rightsholderId)
        const userId = params.userId
        if (!userId) {
            throw new Error('no user id')
        }
        const groups: Array<Partial<PermissionGroups>> = myUserGroups
            .filter((item: MyUserGroup) => item.checked)
            .map((item: MyUserGroup) => ({
                name: item.name,
            }))

        try {
            const rightsholder = await editRightsholderUser(rightsHolderId, userId, groups)
            setRightsholderUser(rightsholder.data)
            setUsersGroup(rightsholder.data)
            await getUsersForUser(rightsholder.data)
            onCloseConfirmPopup()
            onCancelEdit(rightsholder.data)
            popupStore.setAlertData('User permissions have been updated.', false)
        } catch (error) {
            popupStore.setAlertFromError(error)
        }
    }

    return (
        <div className="edit-permissions-popup-content">
            <h3>Want to confirm the permission changes?</h3>
            <p>
                You are updating a user&apos;s permissions. Changing a user&apos;s permissions will impact the
                activities they can perform in this account. Do you want to continue?
            </p>
            <EditActionsGroupsTable editActionsGroups={editActionsGroups} rightsholderUser={rightsholderUser} />
            <div className="buttons">
                <Button mainColor type="secondary" onClick={onCloseConfirmPopup}>
                    Cancel
                </Button>
                <Button mainColor type="primary" onClick={onConfirm}>
                    Confirm
                </Button>
            </div>
        </div>
    )
}

export default observer(ChangePermissionPopup)
